import { ApolloLink } from '@apollo/client';
import { createPersistedQueryLink as createApolloPersistedQueryLink } from '@apollo/client/link/persisted-queries';
import {
  createPersistedQueryManifestVerificationLink as createApolloPersistedQueryManifestVerificationLink,
  generatePersistedQueryIdsFromManifest,
  PersistedQueryManifestForVerification,
} from '@apollo/persisted-query-lists';
import { Logger } from '../services/logging';

const loadManifest = async (): Promise<PersistedQueryManifestForVerification> =>
  (await import('../../persistedQueryManifest.json'))
    .default as PersistedQueryManifestForVerification;

export function createPersistedQueryManifestVerificationLink(logger: Logger): ApolloLink {
  return createApolloPersistedQueryManifestVerificationLink({
    loadManifest,
    onVerificationFailed: (details) => {
      // ignore query body mismatches as long as CDG uses generated queries
      if (details.reason === 'OperationMismatch') {
        return;
      }

      logger.warn(
        `Operation "${details.operation.operationName}" does not match the persisted query manifest (${details.reason}).`,
        {
          reason: details.reason,
          operationName: details.operation.operationName,
        },
      );
    },
  });
}

export default function createPersistedQueryLink() {
  return createApolloPersistedQueryLink({
    ...generatePersistedQueryIdsFromManifest({ loadManifest }),
    retry: () => false,
  });
}

export function createIncludeQueryLink(): ApolloLink {
  return new ApolloLink((operation, forward) => {
    operation.setContext(({ http: prevHttp }) => ({
      http: {
        ...prevHttp,
        includeQuery: true,
      },
    }));

    return forward(operation);
  });
}
